@if (visible()) {
  <div
    class="cookie-banner"
    role="dialog"
    aria-live="polite"
    aria-labelledby="cookie-banner-title"
    aria-describedby="cookie-banner-description"
  >
    <div class="cookie-banner__content">
      <p class="cookie-banner__eyebrow">{{ 'cookie_banner.title' |translate}}</p>
      <p id="cookie-banner-description" class="cookie-banner__text">
        {{ 'cookie_banner.description' |translate}}
        <a routerLink="/pages/privacy-policies" class="cookie-banner__link">
          {{ 'cookie_banner.policy' |translate}}
        </a>
      </p>
    </div>

    <div class="cookie-banner__actions">
      <button
        type="button"
        class="cookie-banner__button cookie-banner__button"
        (click)="reject()"
      >
        {{ 'cookie_banner.reject' |translate}}
      </button>
      <button
        type="button"
        class="cookie-banner__button cookie-banner__button"
        (click)="accept()"
      >
        {{ 'cookie_banner.accept' |translate}}
      </button>
    </div>
  </div>
}
